{
  "name": "front-pos",
  "version": "3.2.0",
  "description": "Suresell POS - Point of Sale System (web / PWA)",
  "author": "Suresell Team",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:staging": "ng serve --configuration=staging",
    "build": "ng build",
    "build:staging": "ng build --configuration=staging",
    "watch": "ng build --watch --configuration development",
    "test": "node scripts/publico-sin-html.mjs && node scripts/csp-de-la-api.mjs --comprobar && ng test --no-watch",
    "vectores:generar": "esbuild src/app/core/offline/generar-vectores-oro.ts --bundle --platform=node --format=esm --outfile=.vectores.mjs && node .vectores.mjs && rm .vectores.mjs",
    "build:publico": "ng build publico --configuration=staging"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@10.9.4",
  "dependencies": {
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@angular/service-worker": "^21.2.5",
    "dexie": "^4.4.4",
    "qrcode-generator": "2.0.4",
    "rxjs": "~7.8.0",
    "sweetalert2": "^11.26.21",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.3",
    "@angular/cli": "^21.1.3",
    "@angular/compiler-cli": "^21.1.0",
    "@types/jasmine": "^6.0.0",
    "fake-indexeddb": "^6.2.5",
    "jsdom": "^27.1.0",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
